import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const iconWidth = css`
    flex-shrink: 0;
    width: 72px;
`;

export const nameWidth = css`
    flex-grow: 1;
    min-width: 100px;
`;

export const dateWidth = css`
    flex-shrink: 0;
    width: 150px;
`;

export const adsAvailabilityWidth = css`
    flex-shrink: 0;
    width: 68px;
`;

export const asAvailabilityWrapper = css`
    display: flex;
    gap: ${Spacing["2XS"]}px;
    align-items: center;
`;

export const visibilityWidth = css`
    flex-shrink: 0;
    width: 120px;
`;

export const statusWidth = css`
    flex-shrink: 0;
    width: 126px;
`;

const buttonSize = 28;
export const actionsWidth = (actionsCount: number): string => css`
    flex-shrink: 0;
    width: ${(actionsCount + 2) * buttonSize + (actionsCount + 1) * Spacing.XS}px;
`;
